import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.section`
  padding: 24px 16px 40px 16px;

  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      padding: 70px 117px;
    }
  `}
`

export const PaymentStepHeading = styled.h2`
  display: none;
  ${({ theme }) => css(theme.typographys.m.regular)};
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: block;
    }
  `}
`

export const PaymentStepDescription = styled.h3`
  display: none;
  ${({ theme }) => css(theme.typographys.tiny.regular)};
  ${({ theme }) => `
    color: ${theme.colors.grey[4]};
    ${theme.breakpoints.desktop} {
      display: block;
      margin-bottom: 27px;
    }
  `}
`
